import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { GET_URL } from '@utils/api/endpoints.ts';

export interface WebhookResponse {
  count: number;
  total_result: number;
  result: WebhookCustomer;
}

export interface WebhookCustomer {
  id: number;
  type: string;
  webhook_url: string;
  webhook_method: string;
  webhook_headers: ['string'];
  organization_id: number;
  created_at: string;
  last_modified: string;
}

export const useGetWebhook = (customerId: number, webhookId: number) => {
  const fetchWebhook = async () => {
    const response = await Axios.get<WebhookResponse>(
      `${GET_URL(customerId.toString(), webhookId.toString()).customerWebhook}`
    );
    return response.data;
  };

  return useQuery<WebhookResponse, AxiosError<BaseError>>(
    ['customerWebhook', customerId, webhookId],
    fetchWebhook,
    {
      onError: () => {
        // Optional: handle error externally if needed
      },
      useErrorBoundary: false
    }
  );
};
